// compile all template strings
import deStrings from "./de";
import enStrings from "./en";
import esStrings from "./es";
import frStrings from "./fr";
import itStrings from "./it";
import jaStrings from "./ja";
import koStrings from "./ko";
import plStrings from "./pl";
import ptStrings from "./pt";
import ruStrings from "./ru";
import trStrings from "./tr";
import zhStrings from "./zh";
export function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}
export function mergeDeep(target, source) {
  const output = { ...target
  };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, {
          [key]: source[key]
        });else output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, {
          [key]: source[key]
        });
      }
    });
  }

  return output;
}
const templateStrings = {};
templateStrings.en = enStrings;
templateStrings.de = mergeDeep(enStrings, deStrings);
templateStrings.es = mergeDeep(enStrings, esStrings);
templateStrings.fr = mergeDeep(enStrings, frStrings);
templateStrings.it = mergeDeep(enStrings, itStrings);
templateStrings.ja = mergeDeep(enStrings, jaStrings);
templateStrings.ko = mergeDeep(enStrings, koStrings);
templateStrings.pl = mergeDeep(enStrings, plStrings);
templateStrings.pt = mergeDeep(enStrings, ptStrings);
templateStrings.ru = mergeDeep(enStrings, ruStrings);
templateStrings.tr = mergeDeep(enStrings, trStrings);
templateStrings.zh = mergeDeep(enStrings, zhStrings);
export default templateStrings;